export default {
  created_date: 'added',
  updated_date: 'updated',
  videos_count: 'videos',
  participants_count: 'participants',
  status: 'status',
  creator: 'creator'
};
